module.exports = __webpack_public_path__ + "img/brightness-alt-high-fill.316185d9.svg";